/**
 * Calendar endpoints
 */
export const calendarEndpoints = {
  slots: () => '/api/calendar/slots',
  appointments: {
    list: () => '/api/appointments/appointments',
    create: () => '/api/appointments/appointments',
    update: (id) => `/api/appointments/appointments/${id}`,
    delete: (id) => `/api/appointments/appointments/${id}`
  },
  unavailabilities: {
    list: () => '/api/appointments/unavailabilities',
    create: () => '/api/appointments/unavailabilities',
    markAvailable: () => '/api/appointments/unavailabilities/mark-available'
  }
}
